export default function convertToBoolean(variable) {
  if (typeof variable == 'boolean') {
    return variable;
  }
  if (
    variable === 1 ||
    variable?.toLowerCase() === 'true'
  ) {
    return true;
  }
  return false;
}